// * hooks
import { AuthProvider } from "./services/auth";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer } from "react-toastify";
// * custom components
import Root from "./Root";
// * styling
import "./App.css";
import "react-toastify/dist/ReactToastify.css";

const queryClient = new QueryClient();
function App() {
  return (
    <div className="h-screen w-screen">
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <Root />
        </QueryClientProvider>
      </AuthProvider>
      <ToastContainer />
    </div>
  );
}

export default App;
